import React, { useEffect } from "react";
import { Outlet, useLocation, matchPath } from "react-router-dom";
import WatiWidget from "../components/WatiChat/WatiWidget";
import Footer from "../components/Footer/Footer";
import { useSelector } from "react-redux";

const Main = ({ className = "" }) => {
  const location = useLocation();
  const hideWidget = useSelector((state) => state.common.hideWidget);
  // const accessToken =
  //   localStorage.getItem("accessToken") ||
  //   sessionStorage.getItem("accessToken");

  const screensHideFooter = [
    "/register",
    "/sign-in",
    "/verify-otp",
    "/qr-scan",
    "/quest/details/completed",
    "/quest/details/multiple/choice/:id",
    "/preview",
    "/system-maintenance",
  ];

  const screensWithViewportFooter = [
    "/profile/withdraw/success",
    // "/quest/details/completed",
  ];

  const screensWithTransparentFixedFooter = [];

  const screensHideWatiChat = [
    "/quest/details/multiple/choice/:id",
    "/quest/details/completed",
  ];

  const shouldHideWatiChat = () => {
    if (hideWidget) return true;
    return screensHideWatiChat?.some((pattern) => {
      if (pattern.includes(":")) {
        return matchPath({ path: pattern }, location.pathname);
      }
      return location.pathname === pattern;
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const shouldHideFooter = () => {
    return screensHideFooter?.some((pattern) => {
      if (pattern.includes(":")) {
        return matchPath({ path: pattern }, location.pathname);
      }
      return location.pathname === pattern;
    });
  };
  const shouldUseViewportFooter = () => {
    return screensWithViewportFooter?.some((pattern) => {
      if (pattern.includes(":")) {
        return matchPath({ path: pattern }, location.pathname);
      }
      return location.pathname === pattern;
    });
  };
  const shouldUseTransparentFixedFooter = () => {
    return screensWithTransparentFixedFooter?.some((pattern) => {
      if (pattern.includes(":")) {
        return matchPath({ path: pattern }, location.pathname);
      }
      return location.pathname === pattern;
    });
  };

  const hideFooter = shouldHideFooter();
  const useViewportFooter = shouldUseViewportFooter();
  const useTransparentFixedFooter = shouldUseTransparentFixedFooter();
  const hideWatiChat = shouldHideWatiChat();

  return (
    <div
      className={`flex flex-col h-full w-full max-w-[480px] mx-auto bg-white min-h-screen relative ${className}`}
    >
      <div
        className={`w-full ${
          useViewportFooter ? "flex-1 min-h-0 pb-[80px]" : ""
        } ${useTransparentFixedFooter ? "" : "pb-[0px]"} ${
          hideFooter ? "pb-[0px]" : ""
        }`}
      >
        <Outlet />
      </div>

      {/* Wati Chat Widget - hiển thị trên cả PublicRoutes và PrivateRoutes */}
      {!hideWatiChat && <WatiWidget />}

      {!hideFooter ? (
        <div
          className={`${
            useTransparentFixedFooter
              ? "fixed bottom-0 left-0 right-0 z-10"
              : "fixed bottom-0 z-10"
          } w-full max-w-[480px] mx-auto left-0 right-0 flex justify-center items-center footer`}
        >
          {/* {accessToken && <WatiWidget />} */}
          <Footer backgroundClass="bg-[#ECEEFF]" />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Main;
